export const menuList = [
  {
    title: "About Us",
    href:"/about-us",
   
  },
  {
    title: "Services",
    href:"/services",
    
  }
];
